import MinusIcon from '@/assets/icons/minus.svg?react'
import PlusIcon from '@/assets/icons/plus.svg?react'

import { StepperButton, StepperContainer, StepperValue } from './styles'

const STEPPER_ICON_SIZE = 24

export type StepperLimit = 'min' | 'max'

interface StepperProps {
  value: number
  onChange: (next: number) => void
  min?: number
  max?: number
  /** 한도 도달 상태에서 버튼을 눌렀을 때 호출. 토스트 등 사용자 안내 트리거용 */
  onLimitReached?: (limit: StepperLimit) => void
}

export function Stepper({ value, onChange, min = 1, max = 99, onLimitReached }: StepperProps) {
  const canDecrease = value > min
  const canIncrease = value < max

  const handleDecrease = () => {
    if (!canDecrease) {
      onLimitReached?.('min')
      return
    }
    onChange(value - 1)
  }

  const handleIncrease = () => {
    if (!canIncrease) {
      onLimitReached?.('max')
      return
    }
    onChange(value + 1)
  }

  return (
    <StepperContainer>
      <StepperButton
        type='button'
        aria-disabled={!canDecrease}
        aria-label='수량 감소'
        onClick={handleDecrease}
      >
        <MinusIcon
          width={STEPPER_ICON_SIZE}
          height={STEPPER_ICON_SIZE}
        />
      </StepperButton>
      <StepperValue>{value}</StepperValue>
      <StepperButton
        type='button'
        aria-disabled={!canIncrease}
        aria-label='수량 증가'
        onClick={handleIncrease}
      >
        <PlusIcon
          width={STEPPER_ICON_SIZE}
          height={STEPPER_ICON_SIZE}
        />
      </StepperButton>
    </StepperContainer>
  )
}
